import { useJsApiLoader } from '@react-google-maps/api';
import { env } from 'constants';
import { AppContext } from 'constants/contexts';
import { debounce } from 'lodash-es';
import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

function AppProvider({ children }) {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = debounce(() => {
      setScrollY(window.scrollY);
    }, 150);

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      handleScroll.cancel();
    };
  }, []);
  const { isLoaded: isGoogleMapsLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: env.GOOGLE_MAPS_API_KEY,
    libraries: ['places', 'geocoding'],
  });
  const contextValue = useMemo(() => ({
    scrollY,
    isGoogleMapsLoaded,
  }), [scrollY, isGoogleMapsLoaded]);

  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
}

AppProvider.useIsScrollAtTop = (threshold = 64) => {
  const { scrollY } = useContext(AppContext);
  return scrollY < threshold;
};
export default AppProvider;
